import { Component } from "preact";
import style from "./index.scss";

export default class WidgetHeader extends Component {
  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
  }
  render({ payload, closeModal }) {
    let heading = payload && payload.header ? payload.header : "Help";
    heading = this.toTitleCase(heading);

    if (payload.appError) heading = "Unexpected Error";

    return (
      <div class={style.supportWidgetHeader}>
        <div style={{ alignItems: "center" }}>
          <h2>{heading}</h2>
        </div>
        <span
          id="closeSupportWidgetId"
          onClick={() => closeModal()}
          onKeyPress={(e) => {
            if (e.keyCode === 13) closeModal();
          }}
          tabIndex="0"
          role="button"
          aria-label="close"
          class={
            "pg-support-widget-cross" + " " + style.supportWidgetHeaderClose
          }
        ></span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/WidgetHeader/index.js